import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _capitalize from "lodash/capitalize";
import _get from "lodash/get";
import _cloneDeep from "lodash/cloneDeep";
import "core-js/modules/es.object.to-string.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import classnames from 'classnames';
import { Button } from "../../Button/Button/Button";
import { Container } from "../../Container/Container/Container";
import { FloatyImage, defaultFloatyImageProps } from "../../FloatyImage/FloatyImage";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { IconItemList } from "../../List/IconItemList/IconItemList";
import { Background } from "../../Background/Background";
import { Text } from "../../Text/Text/Text";
import { PricingForm } from "../../Price/PricingForm/PricingForm";
import { useShowHidePricingFormWithZip } from "../../Utility/Hooks";
import { MatchHeight } from "../../Utility/MatchHeight/MatchHeight";
import styles from "./FeaturesListSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var featuresListSliceAlign = ['left', 'center', 'right'];
export var FeaturesListSlice = function FeaturesListSlice(_ref) {
  var _ref$intro = _ref.intro,
    intro = _ref$intro === void 0 ? {
      eyebrow: {
        text: '',
        typog: 'eyebrow3'
      },
      headline: {},
      errorMessage: {},
      button: {
        type: 'primary'
      },
      footnote: '',
      showPricingForm: false
    } : _ref$intro,
    _ref$list = _ref.list,
    list = _ref$list === void 0 ? {
      align: 'left',
      headline: {},
      iconItems: []
    } : _ref$list,
    background = _ref.background,
    _ref$floatyImage = _ref.floatyImage,
    floatyImage = _ref$floatyImage === void 0 ? defaultFloatyImageProps : _ref$floatyImage;
  var showPricingFormInit = intro && intro.showPricingForm ? intro.showPricingForm : false;
  var _useShowHidePricingFo = useShowHidePricingFormWithZip(showPricingFormInit),
    autoFocus = _useShowHidePricingFo.autoFocus,
    showPricingForm = _useShowHidePricingFo.showPricingForm,
    onZipClick = _useShowHidePricingFo.onZipClick;
  var renderIntro = function renderIntro() {
    if (!intro) {
      return null;
    }
    var eyebrow = intro.eyebrow,
      button = intro.button,
      footnote = intro.footnote,
      headline = intro.headline,
      pricing = intro.pricing,
      errorMessage = intro.errorMessage;
    var renderedPricing = pricing ? _cloneDeep(pricing) : false;
    if (renderedPricing && renderedPricing.pricing && renderedPricing.pricing.input) {
      renderedPricing.pricing.input.autoFocus = autoFocus;
    }

    // If we have no intro, render nothing.
    if ((!eyebrow || !eyebrow.text) && (!headline || !headline.text) && (!button || !button.text) && !footnote && (!errorMessage || !_get(errorMessage, 'text'))) {
      return null;
    }
    return /*#__PURE__*/_jsxs("div", {
      className: styles.intro,
      children: [eyebrow && eyebrow.text && /*#__PURE__*/_jsx(Text, {
        richText: true,
        className: styles.eyebrow,
        typog: eyebrow.typog || 'eyebrow3',
        children: eyebrow.text
      }), headline && headline.text && /*#__PURE__*/_jsx(HeadingText, {
        richText: true,
        ariaLevel: headline.ariaLevel,
        typog: headline.typog || 'headline3',
        children: headline.text
      }), errorMessage && errorMessage.text && /*#__PURE__*/_jsx(Text, {
        typog: "bodycopy",
        className: classnames(styles.error, {
          [styles.errorRed]: errorMessage.red
        }),
        children: errorMessage.text
      }), button && button.url && button.text && /*#__PURE__*/_jsxs("div", {
        className: styles.pricing,
        children: [!showPricingForm && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
          className: styles.cta
        }, button), {}, {
          children: /*#__PURE__*/_jsx(Text, {
            richText: true,
            textElement: "span",
            typog: "bodycopy",
            className: styles.ctaText,
            children: button.text
          })
        })), renderedPricing && /*#__PURE__*/_jsx(PricingForm, {
          pricing: renderedPricing.pricing,
          isOpen: showPricingForm,
          onZipClick: onZipClick
        })]
      }), footnote && /*#__PURE__*/_jsx("div", {
        className: styles.footnote,
        children: /*#__PURE__*/_jsx(Text, {
          richText: true,
          typog: "captionSmall",
          children: footnote
        })
      })]
    });
  };
  var renderList = function renderList() {
    if (!list) {
      return null;
    }
    var align = list.align,
      headline = list.headline,
      iconItems = list.iconItems,
      button = list.button;
    var hasHeadline = headline && headline.text;
    var hasIcons = iconItems.some(function (iconItem) {
      return iconItem.icon && iconItem.icon.image1x;
    });
    return /*#__PURE__*/_jsx("div", {
      className: classnames(styles.list, styles["listAlign".concat(_capitalize(align))], 'priceWrap'),
      children: /*#__PURE__*/_jsx("div", {
        className: styles.content,
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.contentInner,
          children: [hasHeadline && /*#__PURE__*/_jsx(HeadingText, {
            richText: true,
            align: "left",
            variant: headline.variant,
            ariaLevel: headline.ariaLevel,
            typog: headline.typog || 'headline3',
            className: styles.listHeadline,
            children: headline.text
          }), /*#__PURE__*/_jsx(IconItemList, {
            iconItems: iconItems,
            horizontal: true,
            verticalSpacer: {
              padding: 'none'
            }
          }), (button === null || button === void 0 ? void 0 : button.url) && button.text && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, button), {}, {
            className: classnames({
              [styles.listCTA]: true,
              [styles.listCTAHasIcons]: hasIcons
            }),
            children: /*#__PURE__*/_jsx(Text, {
              richText: true,
              textElement: "span",
              typog: "bodycopy",
              className: styles.ctaText,
              children: button.text
            })
          }))]
        })
      })
    });
  };
  return /*#__PURE__*/_jsxs(Background, _objectSpread(_objectSpread({}, background), {}, {
    children: [/*#__PURE__*/_jsx(FloatyImage, _objectSpread({}, floatyImage)), /*#__PURE__*/_jsx("div", {
      className: styles.wrapper,
      children: /*#__PURE__*/_jsxs(Container, {
        children: [renderIntro(), /*#__PURE__*/_jsx(MatchHeight, {
          bypass: "stacked",
          children: renderList()
        })]
      })
    })]
  }));
};